import React from 'react';
import {compose} from 'redux';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid'

import {ReferenceInput, required, SelectInput, TextInput, translate} from 'react-admin';

const styles = {
    checkboxGroup: {
        "& > fieldset > div ": {
            flexDirection: 'column',
        }
    }
}

const LearningOutcomeBatchFields = ({classes, ...props}) => (
    <React.Fragment>
        <Grid item xs={12} sm={6}>
            <TextInput style={{width: '90%'}} source="description"  {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <ReferenceInput source="schoolYearId" reference="schoolYears" validate={required()}   {...props} >
                <SelectInput source="name"/>
            </ReferenceInput>
        </Grid>
    </React.Fragment>
)

export default compose(
    translate,
    withStyles(styles)
)(LearningOutcomeBatchFields)
